import request from '@/utils/request'
// 获取商家列表
export function listCoupon(data) {
  return request({
      url: '/server/coupon/list',
      method: 'get',
      params: data
  })
}






export function getGiveInfo(data) {
  return request({
      url: '/server/coupon/getGiveInfo',
      method: 'get',
      params: data
  })
}
// 用户认证列表
export function addCoupon(data) {
  return request({
      url: '/server/coupon/add',
      method: 'post',
      data: data
  })
}
// 个人信息认证审核
export function getInfo(data) {
  return request({
      url: '/server/coupon/getInfo/' + data,
      method: 'get',
  })
}

